import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';

/**
 * The center component is a layout container component that centers its child within itself.
 */ const Center = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Center', props, ref);
    const { as: Component = 'div', children, css, strategy = 'flex', ...otherProps } = mergedProps;
    const centerCss = useCss(({ mixins })=>strategy === 'flex' ? [
            mixins.flex({
                align: 'center',
                justify: 'center'
            }),
            mixins.size({
                height: '100%'
            })
        ] : {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
        });
    return /*#__PURE__*/ jsx(Component, {
        "data-center": true,
        ...otherProps,
        ref: mergedRef,
        css: [
            centerCss,
            css
        ],
        children: children
    });
});

export { Center };
//# sourceMappingURL=center.js.map
